<template>
    <div class="loader">
        <div class="loader__wrapper">
            <div class="browser-screen-loading-content">
                <div class="loading-dots dark-gray"><i></i><i></i><i></i><i></i></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Loader',
};
</script>

<style src="./loader.scss" lang="scss"></style>
